import { render } from "./CompanyChip.vue?vue&type=template&id=f2ee2164"
import script from "./CompanyChip.vue?vue&type=script&lang=js"
export * from "./CompanyChip.vue?vue&type=script&lang=js"
script.render = render

export default script